import { DOCUMENT, Location } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { TagBloc } from '@kbloc';
import { Constants, QuickAction } from '@kp/shared/constants.service';

@Component({
  selector: 'kp-quick-actions',
  templateUrl: './quick-actions.component.html',
  styleUrls: ['./quick-actions.component.scss'],
})
export class QuickActionsComponent implements OnInit {
  @Input() quickActionsOpen = false;
  @Output() quickActionsToggled = new EventEmitter<boolean>();

  quickActions: QuickAction[];

  // Using Location because Router events are not triggered on first route load
  constructor(@Inject(DOCUMENT) private _document: Document, private _location: Location, private _tagBloc: TagBloc) {}

  ngOnInit() {
    // Set returnUrl on initial load
    this._setQuickActionsReturnUrl();

    // Set returnUrl on url change
    this._location.onUrlChange(() => {
      this._setQuickActionsReturnUrl();
    });
  }

  toggleQuickActions(quickAction?: QuickAction) {
    this.quickActionsOpen = !this.quickActionsOpen;
    this.quickActionsToggled.emit(this.quickActionsOpen);

    if (quickAction?.queryParams?.action === 'add_photo') {
      setTimeout(() => {
        // this needs to be executed as part of a user initiated action, so looking up the clickable
        // element and clicking it as part of the click for the quick action
        (this._document.querySelector('[data-selector="file-input"]') as HTMLElement)?.click();
      }, 300);
    }
  }

  private _setQuickActionsReturnUrl() {
    this.quickActions = Constants.quickActions.map((action) => {
      if (action.returnUrl) {
        return {
          ...action,
          queryParams: {
            ...action.queryParams,
            returnUrl: typeof action.returnUrl === 'string' ? action.returnUrl : this._location.path(),
          },
        };
      }
      return action;
    });
  }
}
